// api开发环境地址

let url = 'https://mmtv2-test-api.linkdoo.cn/'
let sanQrCodeUrl = "http://118.178.234.68:5001/"
const config: Record<string, string> = {
  url: url,
  sanQrCodeUrl: sanQrCodeUrl,
};

// api线上环境地址
if (process.env.NODE_ENV === "production") {
  console.log('yes')
  config.url = "https://mmtv2-api.linkdoo.cn/" //生产环境地址
  config.sanQrCodeUrl = "https://fd.linkdoo.cn/ai/ai/"
}

if (process.env.VUE_APP_BUILD_MODE === 'test') {
  config.url = url;
  config.sanQrCodeUrl = sanQrCodeUrl;
}

export default config;
